const useData = () => {
    const portfolioData = [
        {
            id: "1",
            name: "Luxury Car",
            images: ["/images/luxury", "/images/luxury1", "/images/luxury2", "/images/luxury3"],
            full_img: "/images/full_luxury",
            tools: ["React", "node", "mongodb", "firebase", "express"],
            description: "Modern Looking Luxury car website. where i have added users authentication, authorization, Dashboard Features, Ecommerce functionality.",
            link: "https://luxury-car-ab.netlify.app/",
            features: ["register, Login system", "Dashboard for normal users & admin", "admin can add any product or delete", " admin can make a normal user as a admin", "Private Routes"],
            frontend: "https://github.com/developersidd/luxury_car",
            backend: "https://github.com/developersidd/luxury_car_server_site",
        },
        {
            id: "2",
            name: "ABTravel & Tourism ",
            images: ["/images/tourism", "/images/tourism1", "/images/tourism2", "/images/tourism3", "/images/tourism4",],
            full_img: "/images/full_tourism",
            tools: ["React", "React Router", "mongodb", "firebase", "express"],
            description: "Eye catching user-friendly Tourism website. user can add a tour or manage orders collection, google sing in",
            link: "https://abs-tourism.netlify.app/",
            features: ["Firebase Authentication", "Jw Token", "CRUD operaion", "user can add any product & also can delete"],
            frontend: "https://github.com/developersidd/react-toursim",
            backend: "https://github.com/developersidd/tourism-server",
        },
        {
            id: "3",
            name: "Quiz App ",
            tools: ["React", "Context Api", "firebase"],
            description: "Quiz App is a quiz website, where you can see different types quizes on different languages, it's also has score functionality. if you need help there will be popup video player by watching that video you can find your quiz question answer",
            link: "https://ab-quiz-app.netlify.app/",
            features: ["Quiz functionality", "you can chose quiz on different language", "Private Route", "Register,Login page", "popup video helper"],
            images: ["/images/quizapp", "/images/quiz1", "/images/quiz2", "/images/quiz3"],
            full_img: "/images/quizapp",
            frontend: "https://github.com/developersidd/react-quiz-project",
        },
        {
            id: "4",
            name: "Redux E-commerce",
            tools: ["React", "Redux RTK Query", "firebase", "Tailwind CSS"],
            description: "Redux E-commerce is an E-commerce site developed by React and Redux. User can add any product and check them on cart page and also see the costs. If user logged in or registerted then he/she can access product details, cart page.",
            link: "https://ab-ecomerce-shop.netlify.app/",
            features: ["Cart functionality", "Auth System using Firebase", "Private Route", "Slider"],
            images: ["/images/ecommerce-1", "/images/ecommerce-2", "/images/ecommerce-3"],
            full_img: "/images/ecommerce-full",
            frontend: "https://github.com/developersidd/react-vite-redux-ecommerce",
        }
    ]
    return { portfolioData };
}

export default useData;